import Vue from 'vue'

/*
	工作台组件
*/
// import csTitle from './title/csTitle.vue' //头部标题
// import csHeader from './title/csHeader.vue'//头部导航
// import csContent from './title/csContent.vue' //消息条
// import stepCont from './title/stepCont.vue'// 步骤条

// import messageTell from './components/messageTell.vue'// 消息
// import messageTip from './components/messageTip.vue'// 开标提醒
// import myJobMessage from './components/myJobMessage.vue'// 我的项目信息
// import businessProcessing from './components/businessProcessing.vue'// 业务办理
// import notificationNotice from './components/notificationNotice.vue'// 通知公告
// import toDoitems from './components/toDoitems.vue'// 待办事项
// import openingCalendar from './components/openingCalendar.vue'// 本周开标日历
// import entryProject from './components/entryProject.vue'// 本周进场项目
// import biddingAnnouncement from './components/biddingAnnouncement.vue'// 招标公告
// import projectManagement from './components/projectManagement.vue'// 我的投标项目管理
/*
	全局声明的组件-政采组件
	组件名字要和组件的内部name一致
*/
import showTip from "@/components/signTip.vue";
import onlyPdf from "@/components/dialogOnlyPdf.vue";
import paginations from "@/components/pagination.vue"
import attach from '@/components/attach';
import GTable from '@/components/table';
import approval from '@/components/approval';
import approvalHistory from '@/components/approvalHistory';
import approvalNodeStatus from '@/components/approvalNodeStatus';
import gSignaturePopup from "@/components/signature/popup";


// console.log('===show===',pagination)
// import pdf from 'vue-pdf-cs'

// console.log('===show===',pdf)

var components = [
	// csTitle,
	// csHeader,
	// csContent,

	// messageTell,
	// messageTip,
	// myJobMessage,
	// businessProcessing,
	// notificationNotice,
	// toDoitems,
	// openingCalendar,
	// entryProject,
	// biddingAnnouncement,
	// projectManagement,
	// stepCont,


	showTip,
	onlyPdf,
	paginations,
	attach,
	GTable,
	approval,
	approvalHistory,
	approvalNodeStatus,
	gSignaturePopup
	// pdf,
]
// 遍历扩展组件
 components.map((item,key,arr)=>{
 	Vue.use(item);   // 自定义全局组件的时候需要Vue.use();
	Vue.component(item.name, item); //初始化组件
 })



// WEBPACK FOOTER //
// ./src/extend/vueUse.js